export const environment = {
  name: 'docker-local',
  production: false,
  sw: true,
  GOOGLE_MAPS_KEY: "AIzaSyBmsGyLhFNO2Biw6NEILowie6e_njwK2xQ",
  decryptUrlKey: 'Ps3cKrGYgy2K',
  WMSAuthKey: '6PCdQZ2C!nC9dLj6',
  activePlayer: 'sldp',
  api: 'https://dgc-develop.seventh.com.br',
  socketApi: 'https://dgc-develop.seventh.com.br',
  clientId: 'm0J8mZyUiigIgwh8UxYRs9zMUJ9mcgPY',
  serverPublicKey: 'BCRiFRe-eK27DwkIMwik_eSyVL6fHR_KBBDZs7mxR9SYSp_UZxuJ--5rTggmK8fkyiZgZIOtIv_bCvxHAbjbAAc',
  msal_clientId: '2adfdb2d-7155-49d0-a5fb-27b9225a96d6',
  msal_redirectUri: 'https://dgc-develop.seventh.com.br/',
  msal_authority: 'https://login.microsoftonline.com/common'
};